import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_INVESTCORE_WARDS_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_WARDS_LIST_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTCORE_WARDS_LIST_API_ID,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/wards`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
